export const findThumbURL = (assets, key) => {
    const asset = assets?.videos.find(
        (asset) => asset.name === key && asset.urls?.png
    );

    if (asset) {
        return asset.urls.png;
    }

    return null;
};

export const findVideoURL = (assets, key) => {
    const asset = assets?.videos.find(
        (asset) => asset.name === key && asset.urls?.mp4
    );

    if (asset) {
        return asset.urls.mp4;
    }

    return null;
};

export const fixImageSrc = (url) => {
    // Games images that are turned into nubs are served from
    // invalid URL: /images/iphone_xxx. They need to be transformed
    // into the correct ones which is: /games/photos/iphone_xxx
    return (url || '')
        .replace(/(\/images\/iphone)/, '/games/photos/iphone')
}

export const getImageBySize = (url = '', width = 75, height = 75, skipResizes = []) => {
    const sizedWidth = width === 'full' ? width : Math.round(Number(width))
    const sizedHeight = height === 'full' ? height : Math.round(Number(height))
    let imageSize = width === 'full' && height === 'full' ? `` : `${sizedWidth}x${sizedHeight}/`
    let result = url
        // Thumbnail images are served from URL such as: /images/75x75/image_name.jpg
        .replace(/\/images\/(.*\.(?:jpg|jpeg|png|gif))$/i, `/images/${imageSize}$1`)
        // Nubs images are served from /uploads path and needs to be reformatted to /images/75x75/image_name.jpg
        .replace(/\/uploads\/(.*\.(?:jpg|jpeg|png|gif))$/i, `/images/${imageSize}$1`)
    if (!skipResizes.includes('iphone')) {
        result = result
            // Thumbnail images for photos are served from URL such as: /photo/thumb_image_name.jpg
            .replace(/(\/photos\/iphone)/, '/photos/thumb')
    }
    return result
}

export const replaceStagingBucketsUrl = url => {
    // staging buckets are being returned from some API;
    // this leads to broken assets.
    // Replace staging with production to fix the broken assets:
    return url.replace(/ss-staging/, 'ss-production')
}

export const isValidImageURL = (url, callback) => {
    const img = new Image()
    img.src = url

    // indicates whether or not the image has completely loaded.
    if (img.complete) {
        callback(true)
    // handle image load events
    } else {
        // image successfully loads
        img.onload = () => {
            callback(true)
        }
        // image failed to load, could be an invalid URL
        img.onerror = () => {
            callback(false)
        }
    }
}